(function ($, document) {

    function openHeaderDropdown($dropdown, $associatedControl) {
        $associatedControl.addClass('show-dropdown');
        $dropdown.addClass('active');
        $dropdown.children('.js-up-down').addClass('icon-up');
    }

    function closeHeaderDropdown($dropdown, $associatedControl) {
        $associatedControl.removeClass('show-dropdown');
        $dropdown.removeClass('active');
        $dropdown.children('.js-up-down').removeClass('icon-up');
    }

    function closeHeaderDropdowns() {
        $('.show-dropdown').removeClass('show-dropdown');
        $('.js-show-dropdown.active').removeClass('active');
        $('.js-up-down.icon-up').removeClass('icon-up');
    }

    function repositionDropdownIfNeeded($dropdown, $associatedControl) {

        //Reposition/resize dropdown?
        var dropdownPosition = $dropdown.attr('data-anchor-dropdown');

        if (dropdownPosition == 'left') {
            //Different size/position depending on breakpoint.
            var rowWidth = $('.js-row-width').width();
            var ddRightOffset = 0;
            var ddSize = rowWidth;

            if (Foundation.utils.is_small_only()) {
                //No adjustments needed.
            } else if (Foundation.utils.is_medium_only()) {
                //Centred in row.
                //<i>Could</i> be adjusted to centre on button, but a bit more scripty so up for discussion.
                ddSize = 500;
                ddRightOffset = (rowWidth - ddSize) / 2;
            } else if (Foundation.utils.is_large_up()) {
                //Aligned with left of button
                ddSize = rowWidth - ($dropdown.position().left - 2);
            }


            $associatedControl.css({ 'width': ddSize, 'right': ddRightOffset });
        }
    }


    $(document).ready(function () {
        closeHeaderDropdowns();

        $(document).on('click', '.logged-in-notices', function (e) {
            e.stopPropagation();
            window.location.href = $(this).data('href');
        });

        $(document).on('click', function (e) {
            var $ddl = $('.js-show-dropdown, .show-dropdown');
            if (!$ddl.is(e.target) // if the target of the click isn't the container...
                && $ddl.has(e.target).length === 0) // ... nor a descendant of the container
            {
                //Close any open dropdowns.
                closeHeaderDropdowns();
            }
        });

        $(document).on('click', '.js-show-dropdown', function (e) {
            e.preventDefault();

            var $dropdown = $(this);
            var $associatedControl = $('.' + $dropdown.attr('data-associated-dropdown'));

            if ($(this).hasClass('active')) {
                //Currently open. Hide.
                closeHeaderDropdown($dropdown, $associatedControl);
            } else {
                //Currently hidden. Open.
                //Close any open dropdowns.
                closeHeaderDropdowns();
                repositionDropdownIfNeeded($dropdown, $associatedControl);
                //Open this one
                openHeaderDropdown($dropdown, $associatedControl);
                if ($dropdown.data('scroll') && Foundation.utils.is_small_only()) {
                    $('body').scrollTo($dropdown);
                }
            }

        });
    });


})(jQuery, document);
